module.exports = __webpack_public_path__ + "static/maligaya-bread-4daa221afc1d3f8690fc0a1c4491da32.jpg";